<template>
  <!-- <div _bg="[#FFFFFF]" _h="810px" _pos="relative">
		<div class="ability-detail-header" @click="$router.go(-1)">
			<i class="el-icon-arrow-left" style="margin-right: 5px;font-weight: 1000;"></i>返回
		</div>
    <div _p="x-25px" _flex="~ col justify-center items-center">
      <div _text="28px bold" _m="b-10px">{{ row.title }}</div>
      <div
        class="analysis-container w-cursor-move "
        ref="analysisContainerElement"
        :style="{
          fontSize: '24px',
          fontWeight: 'normal',
          color: '#000',
          fontFamily: '微软雅黑',
          fontStyle: 'normal',
        }"></div>
      <CustomAudio
        ref="audioElement"
        :stopEvent="() => { playTime = null }"
        @getCurrent="(time) => currentTime = time" :playTime="playTime" :musicPath="row.music_path" _pos="absolute" _bottom="0" :style="{
        scale: '1.7',
        left: '50%',
        transformOrigin: 'left top',
        bottom: '35px',
        transform: `translateX(-50%)`
      }"/>
    </div>
  </div> -->
  
  <iframe ref="analysisIframe" style="padding:0; margin: 0; border: 0; width: 100%; height: 810px;" :src="htmlPath" />
</template>

<script>
import CustomAudio from '@/components/CustomAudio.vue'
import TreeView from './treeView.vue'
import { cloneDeep } from 'lodash'
import tinycolor from 'tinycolor2'
export default {
  components: {
    CustomAudio,
    TreeView
  },
  data() {
    return {
      row: {},
      tree: [],
      renderMap: new Map(),
      zoom: 1,
      playTime: null,
      handle: null,
      currentTime: null,
      endTimer: null,
      htmlPath: ''
    }
  },
  async mounted() {
    this.row = window.localStorage.getItem('musicalView')
    if (this.row) {
      this.row = JSON.parse(this.row)
      this.tree = this.treeData()
    }
    this.render()
    this.show()
  },
  methods: {
    treeData() {
      const data = JSON.parse(JSON.stringify(this.row?.extra ?? []))
      const lvList = data.map((v) => v.level)
      const lv = { max: Math.max(...lvList), min: Math.min(...lvList) }
      const _data = new Array(...data.filter((v) => !v.parentId))
      for (let i = lv.min; i <= lv.max; i++) {
        const list = data.filter((v) => v.level === i && v.parentId)
        for (let j = 0; j < list.length; j++) {
          const item = list[j]
          const parent = data.find((v) => v.id == item.parentId)
          if (parent) {
            parent.children = [...(parent.children ?? []), item]
          }
        }
      }
      return _data
    },
    render() {
      this.renderMap.clear()
      /** 数据列表 */
      const cloneRenderDataList = cloneDeep(this.row.extra.sort((prev, next) => prev.level - next.level))
      /** 根数据列表 */
      const rootDataList = cloneRenderDataList.filter((data) => !data.parentId || data.level === 0)
      /** 元素渲染 */
      cloneRenderDataList.forEach((data) => {
        const element = this.renderItem(data)
        this.renderMap.set(data.id, element)
        const parentElement = this.renderMap.get(data.parentId || '')
        if (!parentElement) return
        let childrenContainer = parentElement.querySelector('.level')
        if (!childrenContainer) childrenContainer = new DOMParser().parseFromString('<div class="level"></div>', 'text/html').body.firstElementChild
        parentElement.appendChild(childrenContainer)
        childrenContainer?.appendChild(element)
      })
      if (!this.$refs.analysisContainerElement) return
      // 将根元素添加到容器中
      rootDataList.forEach((data) => {
        const element = this.renderMap.get(data.id)
        if (!element) return
        element.classList.add('root-container')
        this.$refs.analysisContainerElement.appendChild(element)
        let target
        element.onpointerdown = (e) => {
          e.preventDefault()
          e.stopPropagation()
          e.stopImmediatePropagation()
          target = e.target
          target.__startPageX = e.pageX
          target.__startPageY = e.pageY
          target.__isDrag = true
          target.__initX = target.offsetLeft
          target.__initY = target.offsetTop
          // document.addEventListener('pointermove', move)
          // document.addEventListener('pointerup', up)
        }
        this.toParentCenter(element)
        this.initPosition(element, data.id)
      })
    },
    /** 子渲染 */
    renderItem(data) {
      const container = new DOMParser().parseFromString(
        `<div class="analysis-box" data="${encodeURIComponent(JSON.stringify(data))}"></div>`,
        'text/html'
      ).body.firstElementChild
      const itemContainer = new DOMParser().parseFromString(`<div class="analysis-box-container"></div>`, 'text/html').body
        .firstElementChild
      const name = new DOMParser().parseFromString(`<span class="analysis-box-container-name">${data.name}</span>`, 'text/html').body
        .firstElementChild
      const formattedContent = data.content ? Array.from(data.content).join('<br>') : ''
      // const formattedContent = data.content ? Array.from(data.content).map(char => `<span>${char}</span>`).join('') : ''
      console.log(formattedContent, 'geshi')
      const content = new DOMParser().parseFromString(`<div class="analysis-box-container-content">${formattedContent || ''}</div>`, 'text/html')
        .body.firstElementChild
      const contentAbsolute = new DOMParser().parseFromString(
        `<div class="analysis-box-container-content analysis-box-container-content-absolute">${formattedContent || ''}</div>`,
        'text/html'
      ).body.firstElementChild
      name.appendChild(contentAbsolute)
      itemContainer.appendChild(name)
      itemContainer.appendChild(content)
      container.onclick = (e) => {
        e.stopPropagation()
        this.endTimer && clearTimeout(this.endTimer)
        this.playTime = data.start
        this.endTimer = setTimeout(() => this.$refs.audioElement.stop(), (data.end - data.start) * 1000)
      }
      itemContainer.onclick = (e) => {
        e.stopPropagation()
        this.endTimer && clearTimeout(this.endTimer)
        this.playTime = data.start
        this.endTimer = setTimeout(() => this.$refs.audioElement.stop(), (data.end - data.start) * 1000)
      }
      container.appendChild(itemContainer)
      return container
    },
    /** 让父节点居中在border */
    async toParentCenter(element) {
      await this.$nextTick()
      element.style.setProperty('--left', '0')
      const parentName = element.querySelector('.analysis-box-container-name')
      parentName.style.left = '0'
      await this.$nextTick()
      const childrenContainer = element.querySelector('.level')
      if (!childrenContainer) return
      const children = [...childrenContainer.children]
      for (const child of children) {
        await this.toParentCenter(child)
      }
      if (children.length < 2) return
      const firstChild = childrenContainer.firstChild
      const lastChild = childrenContainer.lastChild
      if (!firstChild || !lastChild) return
      const parentNameRect = this.fetchNameElementRect(element)
      const firstChildNameRect = this.fetchNameElementRect(firstChild)
      const lastChildNameRect = this.fetchNameElementRect(lastChild)
      // 计算子元素中心点的平均值
      const firstChildCenter = firstChildNameRect.left + firstChildNameRect.width / 2
      const lastChildCenter = lastChildNameRect.left + lastChildNameRect.width / 2
      const childrenAverageCenter = (firstChildCenter + lastChildCenter) / 2
      // 计算父元素的半宽度
      const parentHalfWidth = parentNameRect.width / 2
      // 计算父元素应调整的left值
      const offsetLeft = childrenAverageCenter - parentNameRect.left - parentHalfWidth
      const left = `${(offsetLeft / this.zoom).toFixed(3)}px`
      parentName.style.left = left
      element.style.setProperty('--left', left)
      await this.$nextTick()
    },
    /** 初始化位置 */
    initPosition(element, id) {
      element.setAttribute('data-id', id)
      element.style.position = 'relative'
      element.style.left = '0'
      element.style.top = '0'
      element.style.marginRight = '20px'
    },
    fetchNameElementRect(element) {
      const nameElement = element.querySelector('.analysis-box-container-name')
      return nameElement.getBoundingClientRect()
    },
    handleIframeMessage(e) {
      if (e.data?.type === 'analysis-ready') {
        const iframe = this.$refs.analysisIframe
        if (iframe && iframe.contentWindow) {
          const analysisData = window.localStorage.getItem('musicalView')
          iframe.contentWindow.postMessage({
            type: 'setAnalysisData',
            data: analysisData // 对象或 JSON 字符串都行
          }, '*')
        }
      }
    },
    show() {
      (this.handle = requestAnimationFrame(() => {
          const value = this.currentTime
          this.renderMap.forEach((element) => {
            const { start, end } = JSON.parse(decodeURIComponent(element.getAttribute('data')))
            if (start <= value && end > value && value > 0) {
              element.style.backgroundColor = tinycolor('#ff5e2a')
              .setAlpha(0.2)
              .toRgbString()
              element.style.color = 'black'
              element.style.textDecorationColor = 'black'
            }
            else {
              element.style.backgroundColor = 'transparent'
              element.style.color = 'black'
              element.style.textDecorationColor = 'black'
            }
          })
        this.show()
      }))
    },
  },
  created() {
    this.htmlPath = `${window.web_config.api_url}/assets/mpptx/analysis-display.html`
    // 监听 iframe 的 message 事件
    window.addEventListener('message', this.handleIframeMessage)
  },
  beforeDestroy() {
    // 组件销毁时移除监听
    window.removeEventListener('message', this.handleIframeMessage)
  } 
}
</script>


<style lang="scss" scoped>
.ability-detail-header {
	display: flex;
	align-items: center;
	font-size: 16px;
	padding: 15px 15px 15px 8px;
	cursor: pointer;
	margin-bottom: 20px;
}
.ability-detail-header:hover {
	color: #ff5e2a;
}

</style>

<style lang="scss">
.analysis-container {
  position: relative;
  overflow: auto;
  display: flex;
  // justify-content: center;
  flex: 1;
  // padding: 0 30px;
  // transition: all 0.s;
  font-weight: bold;
  width: fit-content;
  max-width: 100%;
  margin: 0 auto;
  padding-bottom: 10px;
  scrollbar-width: thin;        /* 可选: thin | auto | none */
  // scrollbar-color: #ff5e2a #f1f1f1; /* thumb 和 track 颜色 */
  .analysis-box {
    width: max-content;
    height: max-content;
    flex-shrink: 0;
    padding: 2px 8px;
    text-align: center;
    position: relative;
    cursor: pointer;
    .analysis-box-container-content {
      word-break: break-all;
      justify-content: center;
      line-break: anywhere;
      line-height: 1.2;
      opacity: 0;
    }
    .analysis-box-container-content:not(.analysis-box-container-content-absolute) {
      opacity: 1;
      margin-top: -3px;
    }
    .analysis-box-container-content-absolute {
      position: absolute;
    }
    .analysis-box-container-name {
      line-height: 1.2;
      position: relative;
      display: inline-block;
    }
  }
  .level {
    display: flex;
    width: fit-content;
    position: relative;
    padding-top: 24px;
    .analysis-box:first-child::before,
    .analysis-box:last-child::after {
      border: 0 none;
    }
    .analysis-box:first-child::after {
      border-left: 3px solid #000;
    }
    .analysis-box:last-child::before {
      border-right: 3px solid #000;
    }
    .analysis-box:only-child::after {
      border: 0 none;
    }
    .analysis-box::before,
    .analysis-box::after {
      content: '';
      position: absolute;
      top: 0;
      right: 50%;
      border-top: 3px solid #000;
      width: 50%;
      height: 20px;
      transform: translateY(-21px) translateX(var(--left));
    }
    .analysis-box::after {
      right: auto;
      left: 50%;
    }
  }
}
.show-scrollbar {
  .analysis-container::-webkit-scrollbar-thumb {
    display: block;
  }
}
.analysis-container::-webkit-scrollbar {
  background-color: transparent !important;
}
.analysis-container::-webkit-scrollbar-thumb {
  border-radius: 0 !important;
  background-color: #00000013 !important;
  display: none;
}

.root-container {
  padding: 5px 8px !important;
}


.root-container {
  margin-right: 20px;
}
</style>
